import { render, staticRenderFns } from "./ShowReviews.vue?vue&type=template&id=245367bc&scoped=true&"
import script from "./ShowReviews.vue?vue&type=script&lang=js&"
export * from "./ShowReviews.vue?vue&type=script&lang=js&"
import style0 from "./ShowReviews.vue?vue&type=style&index=0&id=245367bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "245367bc",
  null
  
)

export default component.exports